import { useEffect, useState } from "react"

import Heading from "~/components/Heading/Heading"
import TimerOption from "~/components/TimerOption/TimerOption"
import CustomTimerModal from "~/components/CustomTimerModal/CustomTimerModal"

import "./TimerPicker.scss"
import { Cycle } from "~/types"

type TimerPickerProps = {
  cycle: Cycle
  onCreate: (minutes: string) => void
}

function TimerPicker(props: TimerPickerProps) {
  const [showCustomTimerModal, setShowCustomTimerModal] = useState(false)
  const { cycle, onCreate } = props
  const cycleIsBreak = cycle === "break"

  useEffect(() => {
    if (showCustomTimerModal) return

    const listener = (event: KeyboardEvent) => {
      // Don't intercept keyboard shortcuts
      const hasModifier =
        event.shiftKey || event.altKey || event.ctrlKey || event.metaKey
      if (hasModifier) return

      if (/[1-9]/.test(event.key)) setShowCustomTimerModal(true)
    }

    window.addEventListener("keydown", listener)
    return () => window.removeEventListener("keydown", listener)
  }, [showCustomTimerModal])

  const minutes = {
    work: [20, 25, 35],
    break: [5, 10],
  }

  const minutesForCycle = cycleIsBreak ? minutes.break : minutes.work

  return (
    <div className="TimerPicker">
      <Heading
        text={cycleIsBreak ? "Let's take a break for" : "Let's work for"}
      />
      <div className="TimerPicker__list">
        {minutesForCycle.map((minute, index) => {
          return (
            <TimerOption
              minutes={minute.toString()}
              key={index}
              cycleIsBreak={cycleIsBreak}
              onClick={onCreate}
            />
          )
        })}
        <TimerOption
          minutes={"??"}
          cycleIsBreak={cycleIsBreak}
          onClick={() => setShowCustomTimerModal(true)}
        />
      </div>

      {showCustomTimerModal && (
        <CustomTimerModal
          cycleIsBreak={cycleIsBreak}
          onDismiss={() => setShowCustomTimerModal(false)}
          onCreate={onCreate}
        />
      )}
    </div>
  )
}

export default TimerPicker
